// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import VueCookie from 'vue-cookie'
import Routers from './router'
import Store from './store'
import Util from './common/util'
import animated from 'animate.css'
import { WOW } from 'wowjs'

Vue.config.productionTip = false

const requireComponent = require.context(
  './components/common/default',
  false,
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  componentConfig.default.install = function (Vue) {
    Vue.component(componentConfig.default.name, componentConfig.default)
  }

  Vue.use(componentConfig.default)
})

Vue.use(VueRouter)
Vue.use(VueCookie)
Vue.use(Vuex)
Vue.use(animated)

Vue.prototype.$util = Util

Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // default
  animateClass: 'animated', // default
  offset: 50, // default
  mobile: true, // default
  live: true,
  callback: function (box) {
    // console.log('WOW: animating <' + box.tagName.toLowerCase() + '>')
  }
})

const router = new VueRouter(Routers)

const store = new Vuex.Store(Store)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  store,
  router,
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js